module.exports = __webpack_public_path__ + "fonts/fira-sans-v16-latin-ext_latin-regular.ttf";